var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import { cx, css } from 'emotion';
import * as colors from '../../styles/colors';
import spacing from '../../styles/spacing';
import { caption } from '../typography/typographyStyles';
var wrapper = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 150px;\n  width: 260px;\n  resize: none;\n  border-radius: 2px;\n  border: 1px solid ", ";\n  padding: 6px ", ";\n  ", "\n  &::placeholder {\n    color: ", ";\n    opacity: 1;\n  }\n"], ["\n  height: 150px;\n  width: 260px;\n  resize: none;\n  border-radius: 2px;\n  border: 1px solid ", ";\n  padding: 6px ", ";\n  ", "\n  &::placeholder {\n    color: ", ";\n    opacity: 1;\n  }\n"])), colors.grey4, spacing.s, caption, colors.grey3);
var disabledStyles = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border: 1px solid ", ";\n  background-color: ", ";\n  color: ", ";\n"], ["\n  border: 1px solid ", ";\n  background-color: ", ";\n  color: ", ";\n"])), colors.grey4, colors.grey5, colors.grey3);
export default (function (_a) {
  var className = _a.className,
      disabled = _a.disabled;
  return cx(wrapper, disabled && disabledStyles, className);
});
var templateObject_1, templateObject_2;